import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Instagram } from 'lucide-react';

export function Footer() {
    const { t } = useLanguage();

    return (
        <footer className="bg-foreground text-white pt-16 pb-8">
            <div className="section-container">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12 pb-12 border-b border-white/10">
                    {/* Brand */}
                    <div className="lg:max-w-sm">
                        <img
                            src="/logo-mark-white.png"
                            alt="Sleepstack"
                            className="h-16 md:h-20 w-auto object-contain block"
                            data-testid="footer-logo"
                        />
                        <p className="mt-5 font-heading text-2xl text-white tracking-tight">
                            {t('footer.brandline')}
                        </p>
                        <div className="flex gap-4 mt-6">
                            <a
                                href="https://www.instagram.com/sleepstack.nl/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white/40 hover:text-secondary transition-colors"
                                aria-label="Instagram"
                                data-testid="footer-instagram"
                            >
                                <Instagram size={20} />
                            </a>
                            <a
                                href="https://www.tiktok.com/@sleepstack.nl"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white/40 hover:text-secondary transition-colors"
                                aria-label="TikTok"
                                data-testid="footer-tiktok"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.01a8.16 8.16 0 0 0 4.77 1.52V7.1a4.85 4.85 0 0 1-1.84-.41z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Link columns, right-aligned to mirror navbar's login/CTA edge */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-10 sm:gap-14 lg:gap-16">
                        {/* Product */}
                        <div>
                            <h4 className="font-heading text-sm uppercase tracking-widest text-white/40 mb-4">
                                {t('footer.product')}
                            </h4>
                            <ul className="space-y-3">
                                <li><Link to="/checkout" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_product.0')}</Link></li>
                                <li><Link to="/science" className="text-sm text-white/70 hover:text-white transition-colors">{t('nav.science')}</Link></li>
                                <li><Link to="/business" className="text-sm text-white/70 hover:text-white transition-colors">{t('nav.business')}</Link></li>
                                <li><Link to="/faq" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_product.3')}</Link></li>
                            </ul>
                        </div>

                        {/* Company */}
                        <div>
                            <h4 className="font-heading text-sm uppercase tracking-widest text-white/40 mb-4">
                                {t('footer.company')}
                            </h4>
                            <ul className="space-y-3">
                                <li><Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_company.0')}</Link></li>
                                <li><Link to="/blog" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_company.1')}</Link></li>
                                <li><a href="mailto:info@sleepstack.nl" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_company.2')}</a></li>
                            </ul>
                        </div>

                        {/* Legal */}
                        <div>
                            <h4 className="font-heading text-sm uppercase tracking-widest text-white/40 mb-4">
                                {t('footer.legal')}
                            </h4>
                            <ul className="space-y-3">
                                <li><Link to="/privacy" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_legal.0')}</Link></li>
                                <li><Link to="/terms" className="text-sm text-white/70 hover:text-white transition-colors">{t('footer.links_legal.1')}</Link></li>
                                <li><Link to="/admin" className="text-sm text-white/40 hover:text-white/80 transition-colors" data-testid="footer-admin-link">Admin</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Bottom */}
                <div className="pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div className="text-xs text-white/30 max-w-lg leading-relaxed">
                        {t('footer.disclaimer')}
                    </div>
                    <div className="text-xs text-white/30 shrink-0 md:text-right">
                        {t('footer.rights')}
                    </div>
                </div>
            </div>
        </footer>
    );
}
